import React from "react";
import { useTranslation } from "react-i18next";
import type { TransformedCart } from "../../types/cartApiTypes";
import CartPageItem from "./CartPageItem";

interface CartPageListProps {
  cart: TransformedCart;
}

const CartPageList: React.FC<CartPageListProps> = ({ cart }) => {
  const { t } = useTranslation();

  return (
    <div className="cart-page-list">
      {/* Header for desktop view */}
      <div className="cart-page-list__header">
        <div className="cart-page-list__header-cell cart-page-list__header-cell--product">
          {t("cartPage.cartPageList.product", "Product")}
        </div>
        <div className="cart-page-list__header-cell">
          {t("cartPage.cartPageList.price", "Price")}
        </div>
        <div className="cart-page-list__header-cell">
          {t("cartPage.cartPageList.quantity", "Quantity")}
        </div>
        <div className="cart-page-list__header-cell">
          {t("cartPage.cartPageList.lineTotal", "Line Total")}
        </div>
      </div>

      {/* List of cart items */}
      <div className="cart-page-list__body">
        {cart.items.map((item) => (
          <CartPageItem key={item.key} item={item} />
        ))}
      </div>
    </div>
  );
};

export default CartPageList;
